import { CheckSolidIcon, CopyIcon, InviteMemberIcon, SuccessfulEmailIcon } from '../../../../../assets/icons';
import { getProfileDataThunk, sendMemberInvitationThunk } from '../../../../../store/workspace/thunks';
import { setInviteMemberModal } from '../../../../../store/workspace/slice';
import { validateEmail } from '../../../../../utils/generalHelpers';
import { useDispatch, useSelector } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import Input from '../../../../../components/Input';
import styles from './style.module.scss';
import { useState } from 'react';
import { selectUserId } from '../../../../../store/auth/selectors';

type Step = 'Form' | 'Done';

export default function InviteMember() {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [step, setStep] = useState<Step>('Form');
    const [email, setEmail] = useState('');
    const [copied, setCopied] = useState(false);
    const [link, setLink] = useState('');
    const [emailError, setEmailError] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const userId = useSelector(selectUserId);

    const copyToClipboard = () => {
        navigator?.clipboard?.writeText(`${link}`).then(() => {
            setCopied(true);
            setTimeout(() => {
                setCopied(false)
            }, 2000);
        })
    };

    const next = () => {
        if (step === 'Done') {
            dispatch(setInviteMemberModal(false));
            return;
        }

        if (!validateEmail(email)) {
            setEmailError('Email address is invalid.');
            return;
        }

        setIsLoading(true);
        setErrorMessage('');
        setEmailError('');

        dispatch(sendMemberInvitationThunk({ email }))
            .unwrap()
            .then((response) => {
                setStep('Done');
                setIsLoading(false);
                setLink(response.invitationLink);
                dispatch(getProfileDataThunk());
            })
            .catch((error) => {
                console.log(error);

                setIsLoading(false);
                setErrorMessage('Error');
            })
    };

    return (
        <Modal
            size='sm'
            icon={<InviteMemberIcon />}
            title='Add member seat'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setInviteMemberModal(false))}
        >
            {step === 'Form' && <div className={styles.form}>
                <span>
                    Please enter the email address of
                    the person you want to add as a member.
                </span>
                <Input
                    type='email'
                    value={email}
                    label='Email address'
                    onChange={setEmail}
                    error={emailError}
                    hasError={Boolean(errorMessage)}
                />
            </div>}

            {step === 'Done' && <div className={styles.success}>
                <SuccessfulEmailIcon />
                <span>Invitation email sent successfully</span>
                <div className={styles.success_link} onClick={copyToClipboard}>
                    <span>{link}</span>
                    {copied ? <CheckSolidIcon /> : <CopyIcon />}
                </div>
            </div>}

            {errorMessage && <span className={styles.error}>{errorMessage}</span>}

            <div className={styles.actions}>
                {step === 'Form' && <Button
                    type='Outline-Primary'
                    text='Cancel'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setInviteMemberModal(false))}
                />}
                <Button
                    type='Primary'
                    onClick={next}
                    loading={isLoading}
                    className={styles.actions_btn}
                    text={step === 'Form' ? 'Send link' : 'Ok'}
                />
            </div>
        </Modal>
    );
};
